_ = require 'underscore'
idleTaskScheduler = require('common/lib/util/idleTaskScheduler').default

mark = (name) ->
  if __DEV__
    try
      performance.mark("#{name}-start")
    catch e
      return

measure = (name) ->
  if __DEV__
    try
      performance.mark("#{name}-end")
      performance.measure("PostRender(#{name})", "#{name}-start", "#{name}-end")
    catch e
      return

module.exports = new class
  constructor: ->
    @holding = false
    @fxs = {}
    @_unnamed = 0
    @_dequeued = {}

  hold: ->
    @holding = true

  # Queued methods need to have a unique name that they are keyed by
  # If the same name is provided multiple times, the callback will get
  # overwritten with the new one, and only called once. If a name is
  # not provided at all, a unique one will be given to it
  enqueue: ([name]..., fx) ->
    name ?= "unnamed_#{ @_unnamed++ }"

    if @holding
      @fxs[name] = =>
        if !@_dequeued[name]
          mark name
          fx({ immediate: false, delayed: true })
          measure name
        else
          delete @_dequeued[name]
    else
      idleTaskScheduler.addTask =>
        if !@_dequeued[name]
          mark name
          fx({ immediate: true, delayed: false })
          measure name
        else
          delete @_dequeued[name]
    return

  dequeue: (name) ->
    @_dequeued[name] = true
    delete @fxs[name]

  release: ->
    @holding = false

    fxToRun = @fxs
    @fxs = {}

    for name, fx of fxToRun when !@_dequeued[name]
      idleTaskScheduler.addTask fx

    return



// WEBPACK FOOTER //
// ./app/scripts/views/lib/post-render.coffee